module.exports = __webpack_public_path__ + "static/media/cameragirl.30c19817.jpg";